// Generated by translation_parser service (parseTranslations.js in the frontend)
export const translations: {[key: string]: {[key: string]: string}} = {
  "units__cow": {
    "en": "cow",
    "pt": "vaca",
    "es": "vaca",
    "fr": "vache",
    "zh": "头",
    "ja": "牛  "
  },
  "units__herd": {
    "en": "herd",
    "pt": "rebanho",
    "es": "rebaño",
    "fr": "troupeau",
    "zh": "牛群",
    "ja": "群"
  },
  "units__day": {
    "en": "d",
    "pt": "dia",
    "es": "día",
    "fr": "jour",
    "zh": "天",
    "ja": "日  "
  },
  "units__month": {
    "en": "mo",
    "pt": "mês",
    "es": "mes",
    "fr": "mois",
    "zh": "月",
    "ja": "月  "
  },
  "units__year": {
    "en": "yr",
    "pt": "ano",
    "es": "año",
    "fr": "an",
    "zh": "年",
    "ja": "年  "
  },
  "units__g": {
    "en": "g",
    "pt": "g",
    "es": "g",
    "fr": "g",
    "zh": "克",
    "ja": "g"
  },
  "units__kg": {
    "en": "kg",
    "pt": "kg",
    "es": "kg",
    "fr": "kg",
    "zh": "kg",
    "ja": "kg"
  },
  "units__lb": {
    "en": "lb",
    "pt": "lb",
    "es": "lb",
    "fr": "lb",
    "zh": "磅",
    "ja": "ポンド  "
  },
  "units__calf": {
    "en": "calf",
    "pt": "bezerro",
    "es": "ternero",
    "fr": "veau",
    "zh": "犊牛",
    "ja": "子牛  "
  },
  "units__dim": {
    "en": "DIM",
    "pt": "DEL",
    "es": "DIM",
    "fr": "JEL",
    "zh": "泌乳天数",
    "ja": "搾乳日数  "
  },
  "units__phase": {
    "en": "group",
    "pt": "grupo",
    "es": "grupo",
    "fr": "groupe",
    "zh": "组别",
    "ja": "グループ  "
  },
  "units__dm": {
    "en": "DM",
    "pt": "MS",
    "es": "MS",
    "fr": "MS",
    "zh": "干物质",
    "ja": "乾物  "
  },
  "units__case": {
    "en": "case",
    "pt": "caso",
    "es": "caso",
    "fr": "cas",
    "zh": "例",
    "ja": "ケース  "
  },
  "units__lw": {
    "en": "LW",
    "pt": "PV",
    "es": "PV",
    "fr": "PV",
    "zh": "体重",
    "ja": "体重"
  },
  "values__units": {
    "en": "Units",
    "pt": "Unidades",
    "es": "Unidades",
    "fr": "Unités",
    "zh": "单位",
    "ja": "単位  "
  },
  "values__current": {
    "en": "Current",
    "pt": "Atual",
    "es": "Actual",
    "fr": "Actuel",
    "zh": "当前的",
    "ja": "現在  "
  },
  "values__adjusted": {
    "en": "Adjusted",
    "pt": "Ajustado",
    "es": "Ajustado",
    "fr": "Ajusté",
    "zh": "调整的",
    "ja": "メタスマート添加"
  },
  "values__reduced": {
    "en": "Adjusted",
    "pt": "Ajustado",
    "es": "Ajustado",
    "fr": "Ajusté",
    "zh": "调整的",
    "ja": "メタスマート添加"
  },
  "values__improved": {
    "en": "Improved",
    "pt": "Ganhos em",
    "es": "Mejoras en",
    "fr": "Amélioré",
    "zh": "改善的",
    "ja": "改善後"
  },
  "values__difference": {
    "en": "Difference",
    "pt": "Diferença",
    "es": "Diferencia",
    "fr": "Différence",
    "zh": "差别",
    "ja": "差"
  },
  "validation__required": {
    "en": "Required",
    "pt": "Solicitado",
    "es": "Requerido",
    "fr": "Obligatoire",
    "zh": "必需的",
    "ja": "必須  "
  },
  "validation__short_password": {
    "en": "8 characters minimum",
    "pt": "Mínimo de 8 caracteres",
    "es": "Mínimo de 8 caracteres",
    "fr": "8 caractères minimum",
    "zh": "至少8个字符",
    "ja": "8文字以上  "
  },
  "validation__password_mismatch": {
    "en": "Passwords must match",
    "pt": "As senhas devem coincidir",
    "es": "Las contraseñas deben coincidir",
    "fr": "Les mots de passe doivent correspondre",
    "zh": "密码必须匹配",
    "ja": "パスワードが一致する必要があります"
  },
  "forgot_password__title": {
    "en": "Reset password",
    "pt": "Redefinir a senha",
    "es": "Restablecer contraseña",
    "fr": "Réinitialiser le mot de passe",
    "zh": "重置密码",
    "ja": "パスワードをリセット  "
  },
  "forgot_password__field__email": {
    "en": "Email",
    "pt": "E-mail",
    "es": "E-mail",
    "fr": "E-mail",
    "zh": "电子邮件",
    "ja": "メール  "
  },
  "forgot_password__button__submit": {
    "en": "Reset password",
    "pt": "Redefinir a senha",
    "es": "Restablecer contraseña",
    "fr": "Réinitialiser le mot de passe",
    "zh": "重置密码",
    "ja": "パスワードをリセット  "
  },
  "forgot_password__link__back_to_login": {
    "en": "Back to login",
    "pt": "Voltar ao login",
    "es": "Volver al inicio de sesión",
    "fr": "Retour à la connexion",
    "zh": "返回登录",
    "ja": "ログイン画面に戻る"
  },
  "forgot_password__link__request_new": {
    "en": "Request a new password reset link",
    "pt": "Solicitar novo link de redefinição de senha",
    "es": "Solicitar un nuevo enlace para restablecer la contraseña",
    "fr": "Demander un nouveau lien de réinitialisation de mot de passe",
    "zh": "发送新密码重置链接",
    "ja": "新しいパスワードリセットリンクをリクエスト  "
  },
  "login__title": {
    "en": "Sign in",
    "pt": "Entrar",
    "es": "Iniciar",
    "fr": "Connecter",
    "zh": "登录",
    "ja": "サインイン  "
  },
  "login__registration_success_msg_1": {
    "en": "Your account has been created and is pending approval.",
    "pt": "Sua conta foi criada e está aguardando aprovação.",
    "es": "Su cuenta ha sido creada y está esperando aprobación.",
    "fr": "Votre compte a été créé et est en attente d'approbation.",
    "zh": "账户已创建，审批中。",
    "ja": "あなたのアカウントは作成されました。承認待ちです。  "
  },
  "login__registration_success_msg_2": {
    "en": "You will receive email notification once your application is approved.",
    "pt": "Você será notificado por e-mail quando sua solicitação for aprovada.",
    "es": "Recibirá una notificación por e-mail cuando su solicitud sea aprobada.",
    "fr": "Vous recevrez un avis par e-mail une fois votre demande approuvée.",
    "zh": "申请获批后将通过电子邮件通知。",
    "ja": "申請が承認されるとメール通知が届きます。  "
  },
  "login__reset_sent_msg_1": {
    "en": "Password reset email was sent.",
    "pt": "O e-mail de redefinição de senha foi enviado.",
    "es": "El e-mail de restablecimiento de contraseña ha sido enviado.",
    "fr": "Un e-mail de réinitialisation du mot de passe a été envoyé.",
    "zh": "密码重置邮件已发送。",
    "ja": "パスワードリセット用メールが送信されました。  "
  },
  "login__reset_sent_msg_2": {
    "en": "Please check your email and follow the instructions.",
    "pt": "Por favor, verifique seu e-mail e siga as instruções.",
    "es": "Por favor, revise su e-mail y siga las instrucciones.",
    "fr": "Veuillez vérifier votre e-mail et suivre les instructions.",
    "zh": "请查收邮箱并按步骤操作。",
    "ja": "メールを確認し、指示に従ってください。  "
  },
  "login__reset_success_msg_1": {
    "en": "The password was successfully reset.",
    "pt": "A senha foi redefinida com sucesso.",
    "es": "La contraseña se restableció con éxito.",
    "fr": "Le mot de passe a été réinitialisé avec succès.",
    "zh": "密码已成功重置。",
    "ja": "パスワードは正常にリセットされました。  "
  },
  "login__reset_success_msg_2": {
    "en": "Please try to sign in with the new password.",
    "pt": "Por favor, tente fazer login com a nova senha.",
    "es": "Por favor, intente iniciar sesión con la nueva contraseña.",
    "fr": "Essayez de vous connecter avec le nouveau mot de passe.",
    "zh": "请尝试使用新密码登录。",
    "ja": "新しいパスワードでサインインを試してください。  "
  },
  "login__field__email": {
    "en": "Email",
    "pt": "E-mail",
    "es": "E-mail",
    "fr": "E-mail",
    "zh": "电子邮件",
    "ja": "メール  "
  },
  "login__field__password": {
    "en": "Password",
    "pt": "Senha",
    "es": "Contraseña",
    "fr": "Mot de passe",
    "zh": "密码",
    "ja": "パスワード  "
  },
  "login__button__submit": {
    "en": "Sign In",
    "pt": "Entrar",
    "es": "Iniciar sesión",
    "fr": "Connexion",
    "zh": "登录",
    "ja": "サインイン  "
  },
  "login__link__forgot_password": {
    "en": "Forgot password?",
    "pt": "Esqueceu a senha?",
    "es": "¿Olvidó su contraseña?",
    "fr": "Mot de passe oublié?",
    "zh": "忘记密码？",
    "ja": "パスワードをお忘れですか？  "
  },
  "login__link__registration": {
    "en": "Don't have an account? Request access",
    "pt": "Não tem uma conta? Solicite acesso.",
    "es": "¿No tiene una cuenta? Solicite acceso.",
    "fr": "Vous n'avez pas de compte? Demander l'accès",
    "zh": "没有账户？申请访问权限",
    "ja": "アカウントをお持ちでないですか？アクセスをリクエスト  "
  },
  "registration__title": {
    "en": "Request Access",
    "pt": "Solicite acesso",
    "es": "Solicitar acceso",
    "fr": "Demander l'accès",
    "zh": "申请访问权限",
    "ja": "アクセスをリクエスト  "
  },
  "registration__field__name": {
    "en": "Name",
    "pt": "Nome",
    "es": "Nombre",
    "fr": "Nom",
    "zh": "姓名",
    "ja": "名前  "
  },
  "registration__field__company": {
    "en": "Company",
    "pt": "Empresa",
    "es": "Empresa",
    "fr": "Société",
    "zh": "公司",
    "ja": "会社  "
  },
  "registration__field__adisseo_contact_name": {
    "en": "Adisseo contact name",
    "pt": "Nome do contato da Adisseo",
    "es": "Nombre de contacto de Adisseo",
    "fr": "Nom du contact Adisseo",
    "zh": "安迪苏联系人姓名",
    "ja": "Adisseo社の担当者"
  },
  "registration__field__email": {
    "en": "Email",
    "pt": "E-mail",
    "es": "E-mail",
    "fr": "E-mail",
    "zh": "电子邮件",
    "ja": "メール  "
  },
  "registration__field__password_1": {
    "en": "Password",
    "pt": "Senha",
    "es": "Contraseña",
    "fr": "Mot de passe",
    "zh": "密码",
    "ja": "パスワード  "
  },
  "registration__field__password_2": {
    "en": "Confirm password",
    "pt": "Confirmar senha",
    "es": "Confirmar contraseña",
    "fr": "Confirmer le mot de passe",
    "zh": "确认密码",
    "ja": "パスワードを確認  "
  },
  "registration__button__submit": {
    "en": "Request Access",
    "pt": "Solicitar acesso",
    "es": "Solicitar acceso",
    "fr": "Demander l'accès",
    "zh": "申请访问权限",
    "ja": "アクセスをリクエスト  "
  },
  "registration__link__login": {
    "en": "Already have an account? Sign in",
    "pt": "Já tem uma conta? Entre",
    "es": "¿Ya tiene una cuenta? Inicie sesión",
    "fr": "Vous avez déjà un compte? Connexion",
    "zh": "已有账户？登录",
    "ja": "すでにアカウントをお持ちですか？サインイン"
  },
  "calc__dashboard__chart__health": {
    "en": "Health",
    "pt": "Saúde",
    "es": "Salud",
    "fr": "Santé",
    "zh": "健康",
    "ja": "健康  "
  },
  "calc__dashboard__chart__repro": {
    "en": "Repro",
    "pt": "Reprodução",
    "es": "Reproducción",
    "fr": "Repro",
    "zh": "繁殖",
    "ja": "繁殖  "
  },
  "calc__dashboard__chart__milk": {
    "en": "Milk",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "产奶",
    "ja": "乳生産"
  },
  "calc__dashboard__chart__investment": {
    "en": "Investment",
    "pt": "Investimento ",
    "es": "Inversión",
    "fr": "Investissement",
    "zh": "投资",
    "ja": "投資  "
  },
  "calc__dashboard__chart__title": {
    "en": "Investment vs. Gross Returns",
    "pt": "Investimento vs. Retornos Brutos",
    "es": "Inversión vs. Retornos Brutos",
    "fr": "Investissement vs. Rendements Bruts",
    "zh": "投资 vs. 总收益",
    "ja": "投資に対する総利益"
  },
  "calc__dashboard__field__aab": {
    "en": "AAB Savings",
    "pt": "Economia BAA",
    "es": "Economía BAA",
    "fr": "Formulation AA",
    "zh": "氨基酸收益"
  },
  "calc__dashboard__field__aab_units": {
    "en": "cents/cow/d",
    "pt": "cent./vaca/d",
    "es": "cent./vaca/d",
    "fr": "cent./vache/j",
    "zh": "分 / 头牛 / 天",
    "ja": "円/牛/日  "
  },
  "calc__dashboard__field__aab_hint": {
    "en": "* for a reformulated diet",
    "pt": "* dieta reformulada",
    "es": "* dieta reformulada",
    "fr": "* ration reformulée",
    "zh": "*调整后日粮",
    "ja": "* 再設計された飼料"
  },
  "calc__dashboard__field__dmi": {
    "en": "DMI",
    "pt": "CMS",
    "es": "CMS",
    "fr": "MSI",
    "zh": "采食量"
  },
  "calc__dashboard__field__dmi_label": {
    "en": "Close-up & Fresh",
    "pt": "Pré- & Pós-parto",
    "es": "Preparto y Fresco",
    "fr": "Autour du Vêlage",
    "zh": "围产和新产",
    "ja": "分娩前後"
  },
  "calc__dashboard__field__herd": {
    "en": "Herd",
    "pt": "Rebanho",
    "es": "Rebaño",
    "fr": "Troupeau",
    "zh": " 牛群",
    "ja": "群"
  },
  "calc__dashboard__field__herd_units": {
    "en": "cows",
    "pt": "vacas",
    "es": "vacas",
    "fr": "vaches",
    "zh": "头",
    "ja": "頭"
  },
  "calc__dashboard__field__units_cow": {
    "en": "Cow",
    "pt": "Vaca",
    "es": "Vaca",
    "fr": "Vache",
    "zh": "奶牛",
    "ja": "1頭"
  },
  "calc__dashboard__field__units_herd": {
    "en": "Herd",
    "pt": "Rebanho",
    "es": "Rebaño",
    "fr": "Troupeau",
    "zh": "牛群",
    "ja": "群"
  },
  "calc__dashboard__field__units_day": {
    "en": "Day",
    "pt": "Dia",
    "es": "Día",
    "fr": "Jour",
    "zh": "天",
    "ja": "日  "
  },
  "calc__dashboard__field__units_mo": {
    "en": "Month",
    "pt": "Mês",
    "es": "Mes",
    "fr": "Mois",
    "zh": "月",
    "ja": "月  "
  },
  "calc__dashboard__field__units_yr": {
    "en": "Year",
    "pt": "Ano",
    "es": "Año",
    "fr": "Année",
    "zh": "年",
    "ja": "年  "
  },
  "calc__dashboard__field__units_kg": {
    "en": "KG",
    "pt": "KG",
    "es": "KG",
    "fr": "KG",
    "zh": "KG",
    "ja": "KG"
  },
  "calc__dashboard__field__units_lb": {
    "en": "LB",
    "pt": "LB",
    "es": "LB",
    "fr": "LB",
    "zh": "磅",
    "ja": "LB"
  },
  "calc__dashboard__button__reset": {
    "en": "Reset",
    "pt": "Resetar",
    "es": "Reiniciar",
    "fr": "Restaurer",
    "zh": "重置",
    "ja": "再入力"
  },
  "calc__dashboard__button__download_pdf": {
    "en": "Download PDF",
    "pt": "Baixar PDF",
    "es": "Descargar PDF",
    "fr": "Télécharger PDF",
    "zh": "下载 PDF",
    "ja": "PDFをダウンロード  "
  },
  "calc__dashboard__button__email_pdf": {
    "en": "Email PDF",
    "pt": "E-mail PDF",
    "es": "Enviar PDF",
    "fr": "E-mail PDF",
    "zh": "邮件发送 PDF",
    "ja": "PDFをメール送信  "
  },
  "calc__pdf_form__field__farm": {
    "en": "Farm",
    "pt": "Fazenda",
    "es": "Granja",
    "fr": "Ferme",
    "zh": "牧场",
    "ja": "農場  "
  },
  "calc__pdf_form__field__nutritionist": {
    "en": "Nutritionist",
    "pt": "Nutricionista ",
    "es": "Nutricionista",
    "fr": "Nutritionniste",
    "zh": "营养师",
    "ja": "設計者  "
  },
  "calc__pdf_form__field__accessed_on": {
    "en": "Assessed on",
    "pt": "Criado em",
    "es": "Creado en",
    "fr": "Évalué sur",
    "zh": "评估时间",
    "ja": "評価日  "
  },
  "calc__pdf_form__field__notes": {
    "en": "Notes",
    "pt": "Anotações",
    "es": "Notas",
    "fr": "Notes",
    "zh": "备注",
    "ja": "メモ  "
  },
  "calc__pdf_form__field__email": {
    "en": "Email",
    "pt": "E-mail",
    "es": "E-mail ",
    "fr": "E-mail ",
    "zh": "电子邮件",
    "ja": "メール  "
  },
  "calc__pdf_form__success__title": {
    "en": "Email sent",
    "pt": "E-mail enviado",
    "es": "E-mail enviado",
    "fr": "E-mail envoyé",
    "zh": "邮件已发送",
    "ja": "メール送信済み  "
  },
  "calc__pdf_form__success__body": {
    "en": "The PDF report was sent to",
    "pt": "O relatório PDF foi enviado para",
    "es": "El informe PDF fue enviado a",
    "fr": "Le rapport PDF a été envoyé à",
    "zh": "PDF 报告已发送至",
    "ja": "PDFレポートは送信されました。"
  },
  "calc__pdf_form__button__cancel": {
    "en": "Cancel",
    "pt": "Cancelar",
    "es": "Cancelar",
    "fr": "Annuler",
    "zh": "取消",
    "ja": "キャンセル  "
  },
  "calc__pdf_form__button__send": {
    "en": "Send PDF",
    "pt": "Enviar PDF",
    "es": "Enviar PDF",
    "fr": "Envoyer le PDF",
    "zh": "发送 PDF",
    "ja": "PDFを送信する"
  },
  "calc__pdf_form__button__download": {
    "en": "Download PDF",
    "pt": "Baixar PDF",
    "es": "Descargar PDF",
    "fr": "Télécharger le PDF",
    "zh": "下载 PDF",
    "ja": "PDFをダウンロード  "
  },
  "calc__pdf_form__button__close": {
    "en": "Close",
    "pt": "Fechar",
    "es": "Cerrar",
    "fr": "Fermer",
    "zh": "关闭",
    "ja": "閉じる  "
  },
  "calc__dashboard__summary__tooltip__sl_2": {
    "en": "Milk + Repro + Health",
    "pt": "Leite + Repro + Saúde",
    "es": "Leche + Repro + Salud",
    "fr": "Lait + Repro + Santé",
    "zh": "产奶+繁殖+健康",
    "ja": "乳量+繁殖+健康  "
  },
  "calc__dashboard__summary__tooltip__sl_3": {
    "en": "(Gross Returns)",
    "pt": "(Retornos Brutos)",
    "es": "(Retornos Brutos)",
    "fr": "(Rendements Bruts)",
    "zh": "（总收益）",
    "ja": "( 総リターン )"
  },
  "calc__dashboard__summary__tooltip__sl_4": {
    "en": "Investment",
    "pt": "Investimento",
    "es": "Inversión",
    "fr": "Investissement",
    "zh": "投资",
    "ja": "投資 "
  },
  "calc__dashboard__summary__tooltip__s_2": {
    "en": "Milk",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "产奶",
    "ja": "乳量  "
  },
  "calc__dashboard__summary__tooltip__s_3": {
    "en": "(Gross Return)",
    "pt": "(Retorno Bruto)",
    "es": "Retorno Bruto",
    "fr": "(Rendements Bruts)",
    "zh": "（总收益）",
    "ja": "( 総リターン )"
  },
  "calc__dashboard__summary__tooltip__s_4": {
    "en": "Investment",
    "pt": "Investimento",
    "es": "Inversión",
    "fr": "Investissement",
    "zh": "投资",
    "ja": "投資  "
  },
  "calc__dashboard__summary__tooltip__i": {
    "en": "Investment",
    "pt": "Investimento",
    "es": "Inversión",
    "fr": "Investissement",
    "zh": "投资",
    "ja": "投資  "
  },
  "calc__dashboard__summary__title": {
    "en": "Investment vs. Net Returns",
    "pt": "Investimento vs. Retornos Líquidos",
    "es": "Inversión vs. Retornos Netos",
    "fr": "Investissement vs. Rendements Nets",
    "zh": "投资 vs. 净回报",
    "ja": "投資に対する純利益"
  },
  "calc__dashboard__summary__subtitle": {
    "en": "IOFC",
    "pt": "RMCA",
    "es": "ISCA",
    "fr": "MCA",
    "zh": "饲料外收益",
    "ja": "IOFC"
  },
  "calc__dashboard__summary__left": {
    "en": "Milk",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "产奶",
    "ja": "乳量  "
  },
  "calc__dashboard__summary__right": {
    "en": "Milk, Repro, & Health",
    "pt": "Leite, Repro, & Saúde",
    "es": "Leche, Repro, &  Salud",
    "fr": "Lait, Repro, & Santé",
    "zh": "产奶, 繁殖, 与 健康",
    "ja": "乳量,繁殖,健康  "
  },
  "calc__dashboard__summary__roi": {
    "en": "ROI",
    "pt": "ROI",
    "es": "ROI",
    "fr": "ROI",
    "zh": "ROI",
    "ja": "ROI"
  },
  "calc__footer": {
    "en": "Underlying model from repro section was adapted from Cabrera 2012 (JDS 95:4683-4698)",
    "pt": "Modelo matemático da seção reprodutiva foi adaptado de Cabrera 2012 (JDS 95:4683-4698)",
    "es": "Modelo matemático de la sección reproductiva fue adaptado de Cabrera 2012 (JDS 95:4683-4698)",
    "fr": "Le modèle sous-jacent de la section de reproduction a été adapté de Cabrera 2012 (JDS 95:4683-4698)",
    "zh": "繁殖模型改编自Cabrera 2012 年的研究(JDS 95:4683-4698)",
    "ja": "繁殖セクションの基盤となるモデルは Cabrera 2012  (JDS 95:4683-4698)を採用しています。 "
  },
  "calc__header__button__help": {
    "en": "Help",
    "pt": "Ajuda",
    "es": "Ayuda",
    "fr": "Aide",
    "zh": "帮助",
    "ja": "ヘルプ  "
  },
  "calc__header__button__logout": {
    "en": "Logout",
    "pt": "Sair",
    "es": "Salir",
    "fr": "Déconnexion",
    "zh": "注销",
    "ja": "ログアウト  "
  },
  "calc__header__title": {
    "en": "MilkSmart - Profitability of AA Balancing",
    "pt": "MilkSmart - Lucratividade com Balanceamento de AA",
    "es": "MilkSmart - Rentabilidad con Balanceo de AA",
    "fr": "MilkSmart - Rentabilité de L'Équilibre en AA",
    "zh": "MilkSmart - 氨基酸平衡收益",
    "ja": "MilkSmart - アミノ酸バランスの収益計算シュミレーション"
  },
  "calc__pdf__header__title": {
    "en": "MilkSmart Report",
    "pt": "Relatório MilkSmart",
    "es": "Informe MilkSmart",
    "fr": "MilkSmart Rapport",
    "zh": "MilkSmart 报告",
    "ja": "MilkSmart レポート  "
  },
  "calc__price_units": {
    "en": "kg of product",
    "pt": "kg de produto",
    "es": "kg de producto",
    "fr": "kg de produit",
    "zh": "产品（kg）",
    "ja": "kg  "
  },
  "calc__investment__field__default_template": {
    "en": "Default template",
    "pt": "Template padrão",
    "es": "Plantilla predeterminada",
    "fr": "Modèle par défaut",
    "zh": "默认模板",
    "ja": "デフォルトテンプレート  "
  },
  "calc__investment__field__template_name": {
    "en": "Template name",
    "pt": "Nome do template",
    "es": "Nombre de la plantilla",
    "fr": "Nom du modèle",
    "zh": "模板名称",
    "ja": "テンプレート名  "
  },
  "calc__investment__button__cancel": {
    "en": "Cancel",
    "pt": "Cancelar",
    "es": "Cancelar",
    "fr": "Annuler",
    "zh": "取消",
    "ja": "キャンセル  "
  },
  "calc__investment__button__save_template": {
    "en": "Save template",
    "pt": "Salvar template",
    "es": "Guardar plantilla",
    "fr": "Enregistrer le modèle",
    "zh": "保存模板",
    "ja": "テンプレートを保存  "
  },
  "calc__investment__column_2": {
    "en": "Far-off",
    "pt": "Secas",
    "es": "Distante",
    "fr": "Tarissement",
    "zh": "干奶期",
    "ja": "乾乳前期  "
  },
  "calc__investment__column_2_tt": {
    "en": "Far-off = 35 d",
    "pt": "Secas = 35 d",
    "es": "Distante = 35 d",
    "fr": "Tarissement = 35 Jours",
    "zh": "干奶期35天",
    "ja": "乾乳前期 = 35日  "
  },
  "calc__investment__column_3": {
    "en": "Close-up",
    "pt": "Pré-Parto",
    "es": "Preparto",
    "fr": "Prépartum",
    "zh": "围产期",
    "ja": "乾乳後期  "
  },
  "calc__investment__column_3_tt": {
    "en": "Close-up = 25 d",
    "pt": "Pré-Parto = 25 d",
    "es": "Preparto = 25 d",
    "fr": "Prépartum = 25 Jours",
    "zh": "围产期25天",
    "ja": "乾乳後期 = 25日  "
  },
  "calc__investment__column_4": {
    "en": "Fresh",
    "pt": "Pós-Parto",
    "es": "Fresco",
    "fr": "Début lact.",
    "zh": "新产期",
    "ja": "フレッシュ期  "
  },
  "calc__investment__column_4_tt": {
    "en": "Fresh = 1 to 30 DIM",
    "pt": "DEL = 1 a 30",
    "es": "DEL = 1 a 30",
    "fr": "JEL = 1 à 30",
    "zh": "新产期=产后1-30天",
    "ja": "フレッシュ期 = 搾乳日数  1～30日"
  },
  "calc__investment__column_5": {
    "en": "Early-Mid lact.",
    "pt": "Iníc.-Meio lact.",
    "es": "Inic.-Medio lact.",
    "fr": "Début-Milieu lact.",
    "zh": "泌乳早期-中期",
    "ja": "泌乳初期～中期  "
  },
  "calc__investment__column_5_tt": {
    "en": "Early-Mid lact. = 30 a 235 DIM",
    "pt": "DEL = 30 a 235",
    "es": "DEL = 30 a 235",
    "fr": "JEL = 30 à 235",
    "zh": "泌乳早期-中期=产后30-235天",
    "ja": "泌乳初期～中期 = 搾乳日数 30～235日"
  },
  "calc__investment__column_6": {
    "en": "Late lact.",
    "pt": "Final lact.",
    "es": "Fin de lact.",
    "fr": "Fin de lact.",
    "zh": "泌乳后期",
    "ja": "泌乳後期  "
  },
  "calc__investment__column_6_tt": {
    "en": "Late lact. = 235 to 305 DIM",
    "pt": "DEL = 235 a 305",
    "es": "DEL = 235 a 305",
    "fr": "JEL = 235 à 305",
    "zh": "泌乳后期=产后235-305天",
    "ja": "泌乳後期 = 搾乳日数  235～305日"
  },
  "calc__investment__1_1": {
    "en": "Herd Structure",
    "pt": "Grupos",
    "es": "Grupos",
    "fr": "Groupes",
    "zh": "牛群结构",
    "ja": "牛群構成"
  },
  "calc__investment__1_2__tt": {
    "en": "The percentage of cows within each group should total 100%.\n\nIf you want to exclude a group from the investment estimates, click on top of the group's name (e.g., \"Close-up\") to eliminate the group from the calculation. Do not place a 0 in this row.",
    "pt": "As porcentagens de vacas dentro de cada grupo deve totalizar 100%.\n\nSe você quiser excluir um grupo das estimativas de investimento, clique acima do nome do grupo (ex. \"Pré-Parto\") para eliminá-lo dos cálculos. Não coloque 0 nesta linha.",
    "es": "Las porcentajes de vacas dentro de cada grupo deben totalizar 100%.\n\nSi desea excluir un grupo de las estimaciones de inversión, haga clic sobre el nombre del grupo (ej. \"Preparto\") para eliminarlo de los cálculos. No coloque 0 en esta línea.",
    "fr": "Le pourcentage de vaches dans chaque groupe doit totaliser 100 %.\n\nSi vous souhaitez exclure un groupe des estimations d’investissement, cliquez sur le nom du groupe (par ex., \"Prépartum\") pour l’éliminer du calcul. Ne mettez pas 0 dans cette ligne.",
    "zh": "各牛群占比总和应为100%。\n\n若投资估算不包含某群牛，请点击该牛群名称（例如“围产牛”）以将其从计算中移除。请勿在此行输入0。",
    "ja": "各グループ内の牛の割合は合計で100％になる必要があります。\n\nシュミレーションから除外したいグループがある場合は、グループ名（例：「乾乳後期」）をクリックして計算から除外してください。この行に0を入力しないでください。"
  },
  "calc__investment__2_2__tt": {
    "en": "Number of cows within each group is obtained through % of cows within group × total cows in the herd.",
    "pt": "Número de vacas dentro de cada grupo é obtido a partir de % de vacas dentro de grupo × total de vacas no rebanho.",
    "es": "El número de vacas dentro de cada grupo se obtiene a partir del % de vacas dentro del grupo × total de vacas el rebaño.",
    "fr": "Le nombre de vaches dans chaque groupe est obtenu par % de vaches dans le groupe × nombre total de vaches dans le troupeau.",
    "zh": "各牛群奶牛头数计算方式如下：各牛群百分比× 奶牛总存栏。",
    "ja": "各グループの頭数は、グループ内の牛の割合 × 牛群の総頭数で求められます。"
  },
  "calc__investment__3_2__tt": {
    "en": "Change feeding rate per group accordingly.\n\nIf you want to exclude a group from the investment estimates, click on top of the group's name (e.g., \"Close-up\") or place a 0 in this row to eliminate the group from the calculation.",
    "pt": "Ajuste a dosagem de produto por grupo, conforme necessário.\n\nSe desejar excluir um grupo das estimativas de investimento, clique acima do nome do grupo (ex. \"Pré-Parto\") ou coloque 0 nesta linha para eliminá-lo do cálculo.",
    "es": "Ajuste la dosificación del producto por grupo, según sea necesario.\n\nSi desea excluir un grupo de las estimaciones de inversión, haga clic sobre el nombre del grupo (ej. \"Preparto\") o coloque un 0 en esta fila para eliminar el grupo del cálculo.",
    "fr": "Ajustez le taux d'alimentation par groupe en conséquence.\n\nSi vous souhaitez exclure un groupe des estimations d'investissement, cliquez sur le nom du groupe (par ex., \"Prépartum\") ou placez un 0 dans cette ligne pour éliminer le groupe du calcul.",
    "zh": "相应调整每群牛的饲喂比例。\n\n若您想将某牛群从投资估算中排除，请点击该牛群名称（例如，“围产牛”）或在该行输入0。",
    "ja": "各グループごとに給与量を適切に変更してください。\n\nシュミレーションから除外したいグループがある場合は、グループ名（例：「乾乳後期」）をクリックするか、この行に0を入力して計算から除外してください。"
  },
  "calc__investment__4_1": {
    "en": "DMI",
    "pt": "CMS",
    "es": "CMS",
    "fr": "MSI",
    "zh": "干物质采食量",
    "ja": "乾物摂取量"
  },
  "calc__investment__4_1__tt": {
    "en": "Be aware that DMI will not affect the investment cost, unless the +DMI button is pressed.\n\nIf you want to exclude a group from the investment estimates, click on top of the group's name (e.g., \"Close-up\") to eliminate the group from the calculation. Do not place a 0 in this row.",
    "pt": "CMS não afetará o custo do investimento, a menos que o botão +CMS seja pressionado.\n\nSe você quiser excluir um grupo das estimativas de investimento, clique acima do nome do grupo (ex. \"Pré-Parto\") para eliminá-lo dos cálculos. Não coloque zero nesta linha.",
    "es": "El CMS no afectará el costo de la inversión, a menos que se presione el botón +CMS.\n\nSi desea excluir un grupo de las estimaciones de inversión, haga clic sobre el nombre del grupo (ej. \"Preparto\") para eliminarlo de los cálculos. No coloque 0 en esta línea.",
    "fr": "Soyez conscient que le MSI (Matière Sèche Ingérée) n’affectera pas le coût de l’investissement, sauf si le bouton +MSI est activé.\n\nSi vous souhaitez exclure un groupe des estimations d’investissement, cliquez sur le nom du groupe (par ex., \"Prépartum\") pour l’éliminer du calcul. Ne mettez pas 0 dans cette ligne.",
    "zh": "干物质采食量不会影响投资成本，除非按下 + 干物质采食量按钮。\n\n若投资估算不包含某群牛，请点击该牛群名称（例如“围产牛”）以将其从计算中移除。请勿在此行输入0。",
    "ja": "乾物摂取量  ボタンを押さない限り、乾物摂取量は投資コストに影響しないことに注意してください。\n\n シュミレーションから除外したいグループがある場合は、グループ名（例：「乾乳後期」）をクリックして計算から除外してください。この行に0を入力しないでください。\""
  },
  "calc__investment__5_1__tt": {
    "en": "If you only see dash in this row, it means that DMI of Methionine-supplemented cows equals that of non-supplemented cows.\n\nIf you press the +DMI button, it increases DMI of Close-up and Fresh cows fed methionine based transition cow studies testing Methionine supplementation (Strzetelski et al. 2009; Osorio et al. 2013; Zhou et al. 2016; Leao et al. 2019; Potts et al. 2020; Michelotti et al. 2021; France et al. 2022).",
    "pt": "Os traços nesta linha significa que o CMS das vacas suplementadas com metionina é igual ao das vacas não suplementadas.\n\nAo pressionar o botão +CMS, o CMS das vacas Pré- e Pós-Parto alimentadas com metionina será aumentado com base em estudos com vacas em transição suplementadas com metionina (Strzetelski et al. 2009; Osorio et al. 2013; Zhou et al. 2016; Leao et al. 2019; Potts et al. 2020; Michelotti et al. 2021; France et al. 2022).",
    "es": "Los trazos en esta línea significan que el CMS de las vacas suplementadas con metionina es igual al de las vacas no suplementadas.\n\nAl presionar el botón +CMS, el CMS de las vacas Pre- y Post-Parto alimentadas con metionina se incrementará según estudios con vacas en transición suplementadas con metionina (Strzetelski et al. 2009; Osorio et al. 2013; Zhou et al. 2016; Leao et al. 2019; Potts et al. 2020; Michelotti et al. 2021; France et al. 2022).",
    "fr": "Si vous ne voyez qu'un tiret dans cette ligne, cela signifie que la MSI des vaches supplémentées en méthionine est égale à celle des vaches non supplémentées.\n\nSi vous appuyez sur le bouton +MSI, cela augmente la MSI des vaches en période de transition (Prépartum et Début de lactation) alimentées avec de la méthionine, sur la base des études sur la supplémentation en méthionine (Strzetelski et al. 2009 ; Osorio et al. 2013 ; Zhou et al. 2016 ; Leao et al. 2019 ; Potts et al. 2020 ; Michelotti et al. 2021 ; France et al. 2022).",
    "zh": "若此行仅显示破折号，则意味着补充蛋氨酸的奶牛与未补充蛋氨酸的奶牛的干物质采食量相等。\n\n若您按下+干物质采食量按钮，围产期和新产期补充蛋氨酸的奶牛采食量将根据围产期奶牛研究结果相应增加（Strzetelski等，2009；Osorio等，2013；Zhou等，2016；Leao等，2019；Potts等，2020；Michelotti等，2021；France等，2022）。",
    "ja": "この行にダッシュのみが表示されている場合、それはメタスマートを与えた牛の乾物摂取量が、与えていない牛と同じであることを意味します。\n\n乾物摂取量  ボタンを押すと、乾乳後期と分娩直後の牛の飼料 摂取量 が増加します。これは、Adisseo社のメチオニン製品を使用した移行期牛の研究（Strzetelski et al. 2009; Osorio et al. 2013; Zhou et al. 2016; Leao et al. 2019; Potts et al. 2020; Michelotti et al. 2021; France et al. 2022）に基づいています。"
  },
  "calc__investment__6_1": {
    "en": "TMR Cost",
    "pt": "Custo TMR",
    "es": "Costo TMR",
    "fr": "Coût Ration",
    "zh": "TMR成本",
    "ja": "TMR飼料コスト"
  },
  "calc__investment__6_1__tt": {
    "en": "Be aware that TMR cost will not affect the investment cost, unless the +DMI button is pressed.",
    "pt": "Custo do TMR não afetará o custo do investimento, a menos que o botão +CMS seja pressionado.\n",
    "es": "El costo del TMR no afectará el costo de la inversión, a menos que se presione el botón +CMS.",
    "fr": "Sachez que le coût de la RTM n'affectera pas le coût de l'investissement, à moins que le bouton +MSI ne soit pressé.",
    "zh": "TMR成本不会影响投资成本，除非按下 + 干物质采食量按钮。",
    "ja": "乾物摂取量のボタンを押さない限り、ＴＭＲ飼料コストは投資コストに影響しないことに注意してください。"
  },
  "calc__investment__8_1": {
    "en": "TMR Cost",
    "pt": "Custo TMR",
    "es": "Costo TMR",
    "fr": "Coût Ration",
    "zh": "TMR成本",
    "ja": "TMR飼料コスト"
  },
  "calc__investment__title": {
    "en": "Investment",
    "pt": "Investimento",
    "es": "Inversión",
    "fr": "Investissement",
    "zh": "投资",
    "ja": "投資  "
  },
  "calc__investment__result_header": {
    "en": "Cost with",
    "pt": "Custo com",
    "es": "Costo con",
    "fr": "Coût avec",
    "zh": "成本",
    "ja": "以下を含むコスト  "
  },
  "calc__investment__result": {
    "en": "AA Balancing",
    "pt": "AA-Balanceamento",
    "es": "AA-Balanceo",
    "fr": "Équilibrage AA",
    "zh": "氨基酸平衡",
    "ja": "アミノ酸バランス調整"
  },
  "calc__milk__column_5": {
    "en": "Milk Pricing",
    "pt": "Preço do Leite",
    "es": "Precio de la Leche",
    "fr": "Prix du Lait",
    "zh": "奶价",
    "ja": "乳価"
  },
  "calc__milk__1_1": {
    "en": "Milk",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "牛奶",
    "ja": "乳量  "
  },
  "calc__milk__1_8": {
    "en": "Milk volume",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "产奶量",
    "ja": "乳量  "
  },
  "calc__milk__2_1": {
    "en": "Fat",
    "pt": "Gordura",
    "es": "Grasa",
    "fr": "TB",
    "zh": "乳脂",
    "ja": "乳脂肪  "
  },
  "calc__milk__2_8": {
    "en": "Fat",
    "pt": "Gordura",
    "es": "Grasa",
    "fr": "TB",
    "zh": "乳脂",
    "ja": "乳脂肪  "
  },
  "calc__milk__3_1": {
    "en": "Protein",
    "pt": "Proteína",
    "es": "Proteína",
    "fr": "TP",
    "zh": "乳蛋白",
    "ja": "乳タンパク質"
  },
  "calc__milk__3_8": {
    "en": "Protein",
    "pt": "Proteína",
    "es": "Proteína",
    "fr": "TP",
    "zh": "乳蛋白",
    "ja": "乳タンパク質"
  },
  "calc__milk__4_1": {
    "en": "Other Solids",
    "pt": "Outros Sólidos",
    "es": "Otros Sólidos",
    "fr": "Autres Solides",
    "zh": "其它固形物",
    "ja": "その他の固形分  "
  },
  "calc__milk__4_8": {
    "en": "Other Solids",
    "pt": "Outros Sólidos",
    "es": "Otros Sólidos",
    "fr": "Autres Solides",
    "zh": "其它固形物",
    "ja": "その他の固形分  "
  },
  "calc__milk__5_1": {
    "en": "ECM",
    "pt": "LCE",
    "es": "LCE",
    "fr": "Lait à 7%",
    "zh": "能量校正乳",
    "ja": "エネルギー補正乳量"
  },
  "calc__milk__5_8": {
    "en": "Quality Premium",
    "pt": "Prêmio de Qualidade ",
    "es": "Premio de Calidad",
    "fr": "Qualité Premium",
    "zh": "优质加价",
    "ja": "品質プレミアム  "
  },
  "calc__milk__6_1": {
    "en": "Fat",
    "pt": "Gordura",
    "es": "Grasa",
    "fr": "TB",
    "zh": "乳脂",
    "ja": "乳脂肪  "
  },
  "calc__milk__7_1": {
    "en": "Protein",
    "pt": "Proteína",
    "es": "Proteína",
    "fr": "TP",
    "zh": "乳蛋白",
    "ja": "乳タンパク質"
  },
  "calc__milk__8_1": {
    "en": "Other Solids",
    "pt": "Outros Sólidos",
    "es": "Otros Sólidos",
    "fr": "Autres Solides",
    "zh": "其它固形物",
    "ja": "その他の固形分  "
  },
  "calc__milk__9_1": {
    "en": "Milk Value",
    "pt": "Valor do Leite",
    "es": "Valor de la Leche",
    "fr": "Valeur du Lait",
    "zh": "牛奶价值",
    "ja": "乳価  "
  },
  "calc__milk__11_1": {
    "en": "Gross Revenue",
    "pt": "Retorno Bruto",
    "es": "Retorno Bruto",
    "fr": "Revenu Brut",
    "zh": "总收益",
    "ja": "総収益 /年 "
  },
  "calc__milk__title": {
    "en": "Milk\nPerformance",
    "pt": "Leite",
    "es": "Leche",
    "fr": "Lait",
    "zh": "牛奶",
    "ja": "乳量  成績"
  },
  "calc__milk__result__title": {
    "en": "Improved",
    "pt": "Ganhos em",
    "es": "Mejoras en",
    "fr": "Amélioration",
    "zh": "改善的",
    "ja": "メタスマート添加"
  },
  "calc__milk__result__subtitle": {
    "en": "Milk Production",
    "pt": "Produção",
    "es": "Producción",
    "fr": "Production",
    "zh": "产奶量",
    "ja": "乳生産"
  },
  "calc__milk__result__tt": {
    "en": "Gross Return\n(Increased Revenue with Milk)",
    "pt": "Retorno Bruto\n(Aumento de Receita com Leite)",
    "es": "Retorno Bruto\n(Aumento de Ingresos con Leche)",
    "fr": "Revenu Brut\n(Augmentation des Revenus Avec le Lait)",
    "zh": "总收益\n（增加的牛奶收入）",
    "ja": "総収益\n（乳による収益の増加）"
  },
  "calc__repro__1_1": {
    "en": "Reproduction Cost",
    "pt": "Custo com Reprodução",
    "es": "Costo con Reproducción",
    "fr": "Coût de Reproduction",
    "zh": "繁殖成本",
    "ja": "繁殖に関わるコスト"
  },
  "calc__repro__1_1__tt": {
    "en": "Insemination-related cost (labor, hormones, semen, pregnancy diagnosis, etc).",
    "pt": "Custo relacionado a inseminação (mão de obra, hormônios, sêmen, diagnóstico de gestação, etc).",
    "es": "Costo relacionado con la inseminación (mano de obra, hormonas, semen, diagnóstico de gestación, etc).",
    "fr": "Coût lié à l'insémination (main-d'œuvre, hormones, semence, diagnostic de gestation, etc.).",
    "zh": "人工授精相关成本（人工、激素、冻精、妊娠诊断等）。",
    "ja": "人工授精に関連するコスト(労働,ホルモン,精液,妊娠鑑定など）"
  },
  "calc__repro__2_1": {
    "en": "Replacement Cost",
    "pt": "Custo de Reposição",
    "es": "Costo de Reposición",
    "fr": "Coût de Remplacement",
    "zh": "替换后备牛成本",
    "ja": "初妊牛の導入コスト"
  },
  "calc__repro__2_1__tt": {
    "en": "Cost to buy a pregnant heifer ready to calve.",
    "pt": "Custo para comprar uma novilha prenha pronta para parir.",
    "es": "Costo para comprar una novilla preñada lista para parir.",
    "fr": "Coût d'achat d'une génisse gestante prête à vêler.",
    "zh": "购买一头即将产犊的青年牛成本。",
    "ja": "分娩準備が整った初妊牛の購入費用"
  },
  "calc__repro__3_1": {
    "en": "Cull Value",
    "pt": "Valor de Abate",
    "es": "Valor de Sacrificio",
    "fr": "Valeur de Réforme",
    "zh": "淘汰价值",
    "ja": "淘汰牛の価値"
  },
  "calc__repro__3_1__tt": {
    "en": "Average price received for cows being culled for meat purposes.",
    "pt": "Preço médio recebido pelas vacas abatidas para fins de carne.",
    "es": "Precio promedio recibido por las vacas sacrificadas para carne.",
    "fr": "Prix moyen reçu pour les vaches mises à l'abattoir pour la viande.",
    "zh": "肉用淘汰奶牛均价",
    "ja": "肉用に淘汰された牛の平均価格"
  },
  "calc__repro__4_1": {
    "en": "Calf Value",
    "pt": "Valor do Bezerro",
    "es": "Valor del Ternero",
    "fr": "Valeur du Veau",
    "zh": "犊牛价值",
    "ja": "子牛の価格"
  },
  "calc__repro__4_1__tt": {
    "en": "A weighted average price for male and female calves born on farm.",
    "pt": "Preço médio ponderado para bezerros machos e fêmeas nascidos na fazenda.",
    "es": "Precio promedio ponderado para terneros machos y hembras nacidos en la granja.",
    "fr": "Prix moyen pondéré pour les veaux mâles et femelles nés à la ferme.",
    "zh": "奶公犊和母犊的加权均价",
    "ja": "農場で生まれた雄牛と雌牛の加重平均価格"
  },
  "calc__repro__5_1": {
    "en": "Insemination Cutoff at ≥",
    "pt": "Limite de Inseminação ≥",
    "es": "Límite de Inseminación ≥",
    "fr": "Limite d’Insémination ≥",
    "zh": "配种截止时间 ≥",
    "ja": "交配の最後の月数"
  },
  "calc__repro__5_1__tt": {
    "en": "Nonpregnant cows beyond this number of months in milk will no longer be eligible for reinsemination.\n\nThis value sets the maximum DIM allowed for breeding (e.g., 10 months ≈ 300 DIM).\n\nAfter exceeding this threshold, cows are not reinseminated and are instead monitored for milk production or evaluated for culling based on performance.",
    "pt": "Vacas não prenhes que ultrapassarem esse número de meses em lactação não serão mais reinseminadas.\n\nEsse valor define o máximo de DEL permitido para inseminação (ex.: 10 meses ≈ 300 DEL).\n\nApós ultrapassar esse limite, as vacas não são mais reinseminadas e são monitoradas pela produção de leite ou avaliadas para descarte, conforme o desempenho.",
    "es": "Las vacas no preñadas que superen este número de meses en lactación ya no serán reinseminadas.\n\nEste valor establece el máximo DEL permitido para inseminación (por ejemplo: 10 meses ≈ 300 DEL).\n\nUna vez superado este umbral, las vacas no se reinseminan y se monitorean por producción de leche o se consideran para descarte, según su rendimiento.",
    "fr": "Les vaches non gestantes ayant dépassé ce nombre de mois en lactation ne seront plus réinséminées.\n\nCette valeur définit le JEL maximal autorisé pour l’insémination (ex.: 10 mois ≈ 300 JEL).\n\nUne fois ce seuil dépassé, les vaches ne sont plus réinséminées ; elles sont soit suivies pour leur production laitière, soit évaluées en vue de leur réforme selon leurs performances.",
    "zh": "空怀奶牛在泌乳达到该月数后将不再进行再次输精。\n\n此值设定了允许配种的最大泌乳天数（例如，10个月 ≈ 300 天）。\n\n超过该阈值后，奶牛将不再进行再次输精，而是根据其产奶性能进行监测或淘汰评估。",
    "ja": "妊娠していない牛を飼育することを許容する月数、または交配させる最後の月数"
  },
  "calc__repro__6_1": {
    "en": "Milk Threshold Post-Cutoff ≤",
    "pt": "Leite Mínimo Aceitável ≤",
    "es": "Leche Mínima Aceptable ≤",
    "fr": "Lait Minimum Acceptable ≤",
    "zh": "截止后产奶量阈值 ≤",
    "ja": "繁殖に必要な最低乳量"
  },
  "calc__repro__6_1__tt": {
    "en": "Used only after the insemination cutoff is reached.\n\nIf a nonpregnant cow is beyond the breeding window (e.g., ≥ 10 months in milk) and her milk yield falls at or below this threshold, she is culled.\n\nOtherwise, she is kept in the herd but not bred again (“Do Not Breed” status).",
    "pt": "Usado apenas após atingir o limite de inseminação.\n\nSe uma vaca não prenhe estiver fora da janela de reprodução (ex.: ≥ 10 meses em lactação) e sua produção de leite estiver igual ou abaixo desse limite, ela será descartada.\n\nCaso contrário, permanece no rebanho, mas não será mais inseminada (status “Não Reinseminar”).",
    "es": "Se utiliza solo después de alcanzar el corte de inseminación.\n\nSi una vaca no preñada supera la ventana de reproducción (por ejemplo: ≥ 10 meses en lactación) y su producción de leche cae por debajo o igual a este umbral, se descarta.\n\nDe lo contrario, permanece en el hato pero no se vuelve a inseminar (estado “No Inseminar”).",
    "fr": "Utilisé uniquement après avoir atteint le seuil d’insémination.\n\nSi une vache non gestante dépasse la période de reproduction (ex.: ≥ 10 mois en lactation) et que sa production laitière est inférieure ou égale à ce seuil, elle est réformée.\n\nSinon, elle reste dans le troupeau mais ne sera plus inséminée (statut “Ne pas réinséminer”).",
    "zh": "仅在达到配种截止条件后使用。\n\n如果空怀奶牛已超出配种期（例如泌乳 ≥ 10 个月），且其产奶量低于或等于该阈值，则被淘汰。\n\n否则，该奶牛继续留在牛群中，但不再进行配种（“不再配种”状态）。",
    "ja": "非妊娠牛を牛群から除去する基準となる乳量。例えば23㎏未満の牛は売却されるなど"
  },
  "calc__repro__7_1": {
    "en": "Culling Rate",
    "pt": "Taxa de Abate",
    "es": "Tasa de Sacrificio",
    "fr": "Taux Réforme",
    "zh": "淘汰率",
    "ja": "淘汰率"
  },
  "calc__repro__7_1__tt": {
    "en": "Herd annual culling rate (percentage of cows leaving the herd during a one-year period).\n\nIncludes both non-pregnant and pregnant culling and mortality culls.",
    "pt": "Taxa anual de abate do rebanho (percentual de animais que deixam o rebanho durante um período de um ano).\n\nA taxa de abate inclui tanto o abate de vacas não prenhas e prenhas, quanto os abates por mortalidade.",
    "es": "Tasa anual de sacrificio del rebaño (porcentaje de animales que dejan el rebaño durante un período de un año).\n\nLa tasa de sacrificio incluye tanto el sacrificio de vacas no preñadas y preñadas, como los sacrificios por mortalidad.",
    "fr": "Taux annuel de réforme du troupeau (pourcentage de vaches quittant le troupeau sur une période d'un an).\n\nInclut à la fois les réformes de vaches gestantes et non gestantes, ainsi que les réformes pour mortalité.",
    "zh": "牛群年度淘汰率（一年中离开牛群的奶牛比例）。\n\n\n包括未孕和怀孕牛的淘汰及死淘。",
    "ja": "牛群の年間淘汰率（1年間で牛群を去る牛の割合）。\n\n妊娠していない牛と妊娠中の牛の淘汰、また死亡による淘汰を含みます。"
  },
  "calc__repro__8_1": {
    "en": "Pregnancy Rate",
    "pt": "Taxa de Prenhez",
    "es": "Tasa de Preñez",
    "fr": "Taux de Fertilité",
    "zh": "怀孕率",
    "ja": "妊娠率"
  },
  "calc__repro__8_1__tt": {
    "en": "Percentage of eligible cows that become pregnant every 28 to 30 d. Note: the typical estrous cycle lasts 21 d.\n\nIt is calculated by dividing the # of cows that become pregnant by the eligible cows within a given period or by multiplying the heat detection rate by the conception rate.\n\nResearch from Cornell-Wisconin has shown an average increase of about 14% in preg rates in cows fed rumen-protected methionine, compared to the control group.",
    "pt": "Taxa de prenhez refere-se ao percentual de vacas elegíveis que ficam prenhas a cada 28 a 30 d.    Nota: ciclo estral típico dura 21 d.\n\nCalculada dividindo o número de vacas que ficam prenhas pelo número de vacas elegíveis em um determinado período, ou multiplicando a taxa de detecção de cio pela taxa de concepção.\n\nPesquisas da Cornell-Wisconsin mostraram um aumento médio na taxa de prenhez de cerca de 14% em vacas alimentadas com metionina protegida, comparado ao grupo controle.",
    "es": "Tasa de preñez se refiere al porcentaje de vacas elegibles que quedan preñadas cada 28 a 30 d.   Nota: ciclo estral típico dura 21 d.\n\nSe calcula dividindo el número de vacas que quedan preñadas por el número de vacas elegibles en un período determinado, o multiplicando la tasa de detección de celo por la tasa de concepción.\n\nInvestigaciones de Cornell-Wisconsin han mostrado un aumento promedio en la tasa de preñez de aproximadamente 14% en vacas alimentadas con metionina protegida, en comparación con el grupo control.",
    "fr": "Pourcentage de vaches éligibles qui deviennent enceintes tous les 28 à 30 jours.\n  Note : le cycle œstral typique dure 21 jours.\n\nIl est calculé en divisant le nombre de vaches enceintes par le nombre de vaches éligibles pendant une période donnée, ou en multipliant le taux de détection des chaleurs par le taux de conception.\n\nLes recherches de Cornell-Wisconsin ont montré une augmentation moyenne d'environ 14 % des taux de grossesse chez les vaches nourries avec de la méthionine protégée pour le rumen, par rapport au groupe témoin.",
    "zh": "每28到30天内，应配奶牛怀孕比例。 备注：典型的发情周期为21天。\n\n计算方法是在指定时间内怀孕牛数量除以应配牛数量或发情揭发率乘以受胎率。\n\n康奈尔-威斯康星大学的研究显示，与对照组相比，补充保护性蛋氨酸的奶牛的怀孕率平均提高了约14%。",
    "ja": "21日周期の妊娠率\nこの値は一定期間内に妊娠した牛の数を発情可能な牛の数で割る、または発情発見率に受胎率を乗じて算出されます。\n\nコーネル大学ウィスコンシン校の研究では、Adisseo社メチオニンを給与した牛は、対照区と比較して妊娠率が平均約14%上昇することが示されています（改善率14% = 0.14 × 21% = 3%)"
  },
  "calc__repro__9_1": {
    "en": "Pregnancy Loss",
    "pt": "Perda de Gestação",
    "es": "Pérdida de Gestación",
    "fr": "Perte de L'Embryon",
    "zh": "妊娠损失",
    "ja": "妊娠の喪失"
  },
  "calc__repro__9_1__tt": {
    "en": "Percentage of cows that lose pregnancy between the 1st and 2nd pregnancy tests, typically conducted 30 and 60 d after AI.\n\nCurrent and adjusted incidences are based on the weighted average of primiparous and multiparous cows from Toledo et al. (2017), testing rumen-protected methionine. In the control group, preg loss between d 18-61 was 17% (15 losses out of 90 cows). Adjusted incidence is based on the methionine-supplemented group (9 losses ÷ 90 = 10%).",
    "pt": "Perda de gestação refere-se à porcentagem de vacas que perdem a gestação entre o 1o e o 2o teste de gravidez, geralmente realizados aos 30 e 60 dias após a inseminação.\n\nAs incidências atuais e ajustadas são baseadas na média ponderada de vacas primíparas e multíparas de Toledo et al. (2017), que avaliou metionina protegida contra fermentação ruminal. No grupo controle, a perda de gestação entre d 18-61 foi de 17% (15 perdas em 90 vacas). A incidência ajustada é baseada no grupo suplementado com metionina (9 perdas ÷ 90 = 10%).",
    "es": "Pérdida de gestación se refiere al porcentaje de vacas que pierden la gestación entre el primer y segundo test de embarazo, generalmente realizados a los 30 y 60 días después de la inseminación.\n\nLas incidencias actuales y ajustadas se basan en el promedio ponderado de vacas primíparas y multíparas de Toledo et al. (2017), que evaluó la metionina protegida. En el grupo control, la pérdida de gestación entre d 18-61 fue del 17% (15 pérdidas de 90 vacas). La incidencia ajustada se basa en el grupo suplementado con metionina (9 pérdidas ÷ 90 = 10%).",
    "fr": "Pourcentage de vaches qui perdent leur grossesse entre le premier et le deuxième test de grossesse, généralement effectués 30 et 60 jours après l'insémination artificielle.\n\nLes incidences actuelles et ajustées sont basées sur la moyenne pondérée des vaches primipares et multipares de Toledo et al. (2017), testant la méthionine protégée pour le rumen. Dans le groupe témoin, la perte de grossesse entre le jour 18 et le jour 61 était de 17 % (15 pertes sur 90 vaches). L'incidence ajustée est basée sur le groupe supplémenté en méthionine (9 pertes ÷ 90 = 10 %).",
    "zh": "在第一次和第二次妊娠检测之间流产的奶牛占比，通常在人工授精后30天和60天进行检测。\n\n当前和调整后的发生率基于Toledo等人（2017年）补充保护性蛋氨酸的试验中头胎牛和经产牛的加权平均值。对照组18至61天之间的妊娠损失率为17%（90头奶牛中有15头流产）。调整后的发生率基于补充蛋氨酸组（9头流产 ÷ 90 = 10%）。",
    "ja": "妊娠鑑定（人工授精後30日～60日で実施）で確認された胚死滅の割合。\n\n数値はToledo et al.（2017）の論文に基づいている：Adisseo社メチオニンを給与した初産牛および経産牛の結果の加重平均。対照区、18～61日間の早期胚死滅割合は17%（90頭中15頭）に対し、メチオニン添加区の発生率は10% （90頭中15頭）。"
  },
  "calc__repro__10_1": {
    "en": "Calf Sales",
    "pt": "Vendas de Bezerros",
    "es": "Venta de Terneros",
    "fr": "Vente de Veaux",
    "zh": "出售犊牛",
    "ja": "子牛販売価格"
  },
  "calc__repro__11_1": {
    "en": "Mortality Cost",
    "pt": "Custo de Mortalidade",
    "es": "Costo de Mortalidad",
    "fr": "Coût de la Mortalité",
    "zh": "死淘成本",
    "ja": "死亡によるコスト  "
  },
  "calc__repro__12_1": {
    "en": "Reproductive Cost",
    "pt": "Custo Reprodutivo",
    "es": "Costo Reproductivo",
    "fr": "Coût de Reproduction",
    "zh": "繁殖成本",
    "ja": "繁殖に関するコスト"
  },
  "calc__repro__13_1": {
    "en": "Reproductive Culling Cost",
    "pt": "Custo de Abate Reprodutivo",
    "es": "Costo de Sacrificio Reproductivo",
    "fr": "Coût de L'Abattage Reproductif",
    "zh": "繁殖淘汰成本",
    "ja": "繁殖不全による淘汰コスト"
  },
  "calc__repro__14_1": {
    "en": "Non-Reprod. Culling Cost",
    "pt": "Custo de Abate Não-Reprodutivo",
    "es": "Costo de Sacrificio No-Reproductivo",
    "fr": "Coût de L'Abattage Non-Reprod. ",
    "zh": "非繁殖问题淘汰成本",
    "ja": "繁殖不全以外の理由による淘汰コスト"
  },
  "calc__repro__15_1": {
    "en": "Gross Return",
    "pt": "Retorno Bruto",
    "es": "Retorno Bruto",
    "fr": "Revenu Brut",
    "zh": "总收益",
    "ja": "総収益"
  },
  "calc__repro__title": {
    "en": "Reproductive\nPerformance",
    "pt": "Reprodução",
    "es": "Reproducción",
    "fr": "Reproduction",
    "zh": "繁殖性能",
    "ja": "繁殖 成績"
  },
  "calc__repro__result__tt": {
    "en": "Gross Return\n(Savings with Reproduction)",
    "pt": "Retorno Bruto\n(Redução de Custos com Reprodução)",
    "es": "Retorno Bruto\n(Ahorro con Reproducción)",
    "fr": "Revenu Brut\n(Économies Liées à la Reproduction)",
    "zh": "总收益\n(繁殖节约成本)",
    "ja": "総収益\n（繁殖成績改善によるコスト削減）"
  },
  "calc__repro__result__title": {
    "en": "Improved",
    "pt": "Ganhos em",
    "es": "Mejoras en",
    "fr": "Amélioration",
    "zh": "改善的",
    "ja": "改善後"
  },
  "calc__repro__result__subtitle": {
    "en": "Reproduction",
    "pt": "Reprodução",
    "es": "Reproducción",
    "fr": "Reproduction",
    "zh": "繁殖性能",
    "ja": "繁殖  "
  },
  "calc__health__column_1_3": {
    "en": "Incidence",
    "pt": "Incidência",
    "es": "Incidencia",
    "fr": "Incidence",
    "zh": "发生率",
    "ja": "発生率  "
  },
  "calc__health__column_1_4": {
    "en": "Cost",
    "pt": "Custo",
    "es": "Costo",
    "fr": "Coût",
    "zh": "成本",
    "ja": "コスト  "
  },
  "calc__health__column_1_5": {
    "en": "Cost",
    "pt": "Custo",
    "es": "Costo",
    "fr": "Coût",
    "zh": "成本",
    "ja": "コスト  "
  },
  "calc__health__column_2_2_1": {
    "en": "Units",
    "pt": "Unidades",
    "es": "Unidades",
    "fr": "Unités",
    "zh": "单位",
    "ja": "単位  "
  },
  "calc__health__column_2_2_2": {
    "en": "Incidence",
    "pt": "Incidência",
    "es": "Incidencia",
    "fr": "Incidence",
    "zh": "发生率",
    "ja": "発生率  "
  },
  "calc__health__column_2_3": {
    "en": "Current",
    "pt": "Atual",
    "es": "Actual",
    "fr": "Actuel",
    "zh": "当前的",
    "ja": "現在"
  },
  "calc__health__column_2_3__tt": {
    "en": "Current incidences of diseases are averaged from literature references (Guard, 2008; Gonçalves et al., 2022).",
    "pt": "Incidências atuais são médias obtidas de referências na literatura (Guard, 2008; Gonçalves et al., 2022).",
    "es": "Incidencias actuales son promedios obtenidos de referencias en la literatura (Guard, 2008; Gonçalves et al., 2022). ",
    "fr": "L'incidence moyenne des maladies est basée sur quelques références dans la littérature (Guard, 2008 ; Gonçalves et al., 2022).",
    "zh": "当前平均疾病发生率引自文献资料（Guard, 2008; Gonçalves 等, 2022）。",
    "ja": "疾病の現在の発生率は文献（Guard, 2008; Gonçalves et al., 2022）からの平均値を採用しています。"
  },
  "calc__health__column_2_4": {
    "en": "Adjusted",
    "pt": "Ajustado",
    "es": "Ajustado",
    "fr": "Ajusté",
    "zh": "调整的",
    "ja": "メチオニン添加"
  },
  "calc__health__column_2_4__tt": {
    "en": "The reduced incidence was calculated as the average percentage reduction of each disease with methionine supplementation, based on a few references (Osorio et al., 2013; Stangaferro et al., 2017; Zhou et al., 2016).\n\nMastitis  ⇩  ~35%  e.g., 2 - (0.35 × 2) = 1.3\nKetosis (clin.)  ⇩  ~44%  e.g., 6 - (0.44 × 6) = 3.4\nKetosis (subclin.)  ⇩  ~44%  e.g., 40 - (0.44 × 40) = 22\nMetritis  ⇩  ~43%  e.g., 15 - (0.43 × 15) = 8.6",
    "pt": "A incidência reduzida foi calculada com base na redução percentual média de cada doença com a suplementação de metionina, segundo algumas referências (Osorio et al., 2013; Stangaferro et al., 2017; Zhou et al., 2016).\n\nMastite  ⇩  ~35%  e.g., 2 - (0.35 × 2) = 1.3\nCetose (clín.)  ⇩  ~44%  e.g., 6 - (0.44 × 6) = 3.4\nCetose (subclín.)  ⇩  ~44%  e.g., 40 - (0.44 × 40) = 22\nMetrite  ⇩  ~43%  e.g., 15 - (0.43 × 15) = 8.6",
    "es": "La incidencia reducida fue calculada en base a la reducción percentual promedio de cada enfermedad con la suplementación de metionina, según algunas referencias (Osorio et al., 2013; Stangaferro et al., 2017; Zhou et al., 2016).\n\nMastitis  ⇩  ~35%  e.g., 2 - (0.35 × 2) = 1.3\nCetosis (clín.)  ⇩  ~44%  e.g., 6 - (0.44 × 6) = 3.4\nCetosis (subclín.)  ⇩  ~44%  e.g., 40 - (0.44 × 40) = 22\nMetritis  ⇩  ~43%  e.g., 15 - (0.43 × 15) = 8.6",
    "fr": "La réduction de l'incidence a été calculée sur la base du pourcentage moyen de réduction de chaque maladie avec la supplémentation en méthionine sur la base de quelques références (Osorio et coll., 2013 ; Stangaferro et coll., 2017 ; Zhou et al., 2016).\n\nMammite  ⇩  ~35%  e.g., 2 - (0.35 × 2) = 1.3\nCétose (clin.)  ⇩  ~44%  e.g., 6 - (0.44 × 6) = 3.4\nCétose (subclin.)  ⇩  ~44%  e.g., 40 - (0.44 × 40) = 22\nMétrite  ⇩  ~43%  e.g., 15 - (0.43 × 15) = 8.6",
    "zh": "降低后的发病率基于参考文献（Osorio等, 2013; Stangaferro等, 2017; Zhou等, 2016）得出的补充蛋氨酸对疾病发生率的降低。\n\n乳房炎    ⇩   ~35%      例如   2 - (0.35 × 2) = 1.3\n酮病 （临床）    ⇩   ~44%      例如   6 - (0.44 × 6) = 3.4\n酮病（亚临床）    ⇩   ~44%      例如   40 - (0.44 × 40) = 22\n子宫炎    ⇩   ~43%      例如   15 - (0.43 × 15) = 8.6",
    "ja": "疾病発生率の減少は、Adisseo社メチオニンの給与試験結果より各疾病の平均減少率として計算されています。　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　（Osorio et al., 2013; Stangaferro et al., 2017; Zhou et al., 2016 ）\n\n乳房炎減少率   約35% 例：2 - (0.35 × 2) = 1.3  \nケトーシス（臨床性）減少率  約44% 例：6 - (0.44 × 6) = 3.4  \nケトーシス（潜在性） 減少率 約44% 例：40 - (0.44 × 40) = 22  \n子宮内膜炎 減少率  約43% 例：15 - (0.43 × 15) = 8.6"
  },
  "calc__health__column_2_5__tt": {
    "en": "The disease management costs were adapted from a few references (Guard, 2008; Kelton et al., 1998; McArt et al., 2015).",
    "pt": "O custos de controle de doenças foram adaptados de algumas referências (Guard, 2008; Kelton et al., 1998; McArt et al., 2015).",
    "es": "Los costos de control de enfermedades fueron adaptados de algunas referencias (Guard, 2008; Kelton et al., 1998; McArt et al., 2015).",
    "fr": "Le coût de la prise en charge de la maladie est basé sur des données adaptées de quelques références (Guard, 2008 ; Kelton et coll., 1998 ; McArt et coll., 2015).",
    "zh": "疾病管理成本基于参考资料（Guard, 2008; Kelton 等, 1998; McArt 等, 2015）。",
    "ja": "疾病管理に関わるコストの出典元：Guard, 2008; Kelton et al., 1998; McArt et al., 2015"
  },
  "calc__health__1_1": {
    "en": "Mastitis (clinical)",
    "pt": "Mastite (clínica)",
    "es": "Mastitis (clínica)",
    "fr": "Mammite (clin.)",
    "zh": "乳房炎（临床型）",
    "ja": "乳房炎（ 臨床 ）  "
  },
  "calc__health__1_2": {
    "en": "% milking cows/mo",
    "pt": "% vacas lact./mês",
    "es": "% vacas lact./mes",
    "fr": "% vaches lait./mois",
    "zh": "每月泌乳牛比例",
    "ja": "搾乳牛の割合/月  "
  },
  "calc__health__2_1": {
    "en": "Ketosis (clinical)",
    "pt": "Cetose (clínica)",
    "es": "Cetosis (clínica)",
    "fr": "Cétose (clin.)",
    "zh": "酮病（临床型）",
    "ja": "ケトーシス（ 臨床 ）  "
  },
  "calc__health__2_2": {
    "en": "% fresh cows",
    "pt": "% vacas pós-parto",
    "es": "% vacas frescas",
    "fr": "% vaches fraîches",
    "zh": "新产牛比例",
    "ja": "% フレッシュ牛"
  },
  "calc__health__3_1": {
    "en": "Ketosis (subclin.)",
    "pt": "Cetose (subclín.)",
    "es": "Cetosis (subclín.)",
    "fr": "Cétose (subclin.)",
    "zh": "酮病（亚临床型）",
    "ja": "ケトーシス（ 潜在）  "
  },
  "calc__health__3_2": {
    "en": "% fresh cows",
    "pt": "% vacas pós-parto",
    "es": "% vacas frescas",
    "fr": "% vaches fraîches",
    "zh": "新产牛比例",
    "ja": "% フレッシュ牛"
  },
  "calc__health__4_1": {
    "en": "Metritis",
    "pt": "Metrite",
    "es": "Metritis",
    "fr": "Métrite",
    "zh": "子宫炎",
    "ja": "子宮炎"
  },
  "calc__health__4_2": {
    "en": "% fresh cows",
    "pt": "% vacas pós-parto",
    "es": "% vacas frescas",
    "fr": "% vaches fraîches",
    "zh": "新产牛比例",
    "ja": "% フレッシュ牛"
  },
  "calc__health__5_1": {
    "en": "Gross Return",
    "pt": "Retorno Bruto",
    "es": "Retorno Bruto",
    "fr": "Revenu Brut",
    "zh": "总收益",
    "ja": "総収益  "
  },
  "calc__health__title": {
    "en": "Health Status",
    "pt": "Saúde",
    "es": "Salud",
    "fr": "Santé",
    "zh": "健康状况",
    "ja": "健康"
  },
  "calc__health__result__tt": {
    "en": "Gross Return\n(Savings with Health)",
    "pt": "Retorno Bruto\n(Redução de Custos com Saúde)",
    "es": "Retorno Bruto\n(Ahorro con la Salud)",
    "fr": "Revenu Brut\n(Économies Liées à la Santé)",
    "zh": "总收益\n(健康改善的收益)",
    "ja": "総収益\n（健康による収益の増加）"
  },
  "calc__health__result__title": {
    "en": "Improved",
    "pt": "Ganhos em",
    "es": "Mejoras en",
    "fr": "Amélioration",
    "zh": "改善的",
    "ja": "改善後"
  },
  "calc__health__result__subtitle": {
    "en": "Health",
    "pt": "Saúde",
    "es": "Salud",
    "fr": "Santé",
    "zh": "健康",
    "ja": "健康  "
  },
  "api__err__not_authenticated": {
    "en": "User not authenticated",
    "pt": "Usuário não autenticado",
    "es": "Usuario no autenticado",
    "fr": "Utilisateur non authentifié",
    "zh": "未授权用户",
    "ja": "ユーザーが認証されていません  "
  },
  "api__err__auth__rejected": {
    "en": "Registration of this user is rejected",
    "pt": "O registro deste usuário foi rejeitado",
    "es": "El registro de este usuario ha sido rechazado",
    "fr": "L'inscription de cet utilisateur est rejetée",
    "zh": "该用户被拒绝注册",
    "ja": "このユーザーの登録は拒否されました  "
  },
  "api__err__auth__pending": {
    "en": "This account is pending approval",
    "pt": "Esta conta está com a aprovação pendente ",
    "es": "Esta cuenta está pendiente de aprobación",
    "fr": "Ce compte est en attente d'approbation",
    "zh": "该账户正在等待审批",
    "ja": "このアカウントは承認待ちです  "
  },
  "api__err__auth__not_found": {
    "en": "This email is not registered",
    "pt": "Este e-mail não está registrado",
    "es": "Este e-mail no está registrado",
    "fr": "Cet e-mail n'est pas enregistré",
    "zh": "该邮箱未被注册",
    "ja": "このメールは登録されていません  "
  },
  "api__mutation__calculate__err__negative_herd_size": {
    "en": "Herd size must be greater than 0",
    "pt": "O tamanho do rebanho deve ser maior que 0",
    "es": "El tamaño del rebaño debe ser mayor que 0",
    "fr": "La taille du troupeau doit être supérieure à 0",
    "zh": "牛群大小必须大于零",
    "ja": "牛群サイズは0より大きくする必要があります"
  },
  "api__mutation__forgot_password__email__subject": {
    "en": "Password reset",
    "pt": "A senha foi redefinida",
    "es": "La contraseña ha sido restablecida",
    "fr": "Le mot de passe a été réinitialisé",
    "zh": "密码已重置",
    "ja": "パスワードのリセット"
  },
  "api__mutation__forgot_password__email__body_1": {
    "en": "Here is the one-time link to reset your password:",
    "pt": "Aqui está o link único para redefinir sua senha:",
    "es": "Aquí está el enlace único para restablecer su contraseña:",
    "fr": "Voici le lien à usage unique pour réinitialiser votre mot de passe:",
    "zh": "以下是重置您密码的一次性链接：",
    "ja": "こちらはパスワードをリセットするための1回限りのリンクです：  "
  },
  "api__mutation__forgot_password__email__body_2": {
    "en": "If you did not request this, please ignore this email",
    "pt": "Se você não solicitou isso, por favor, ignore este e-mail",
    "es": "Si no solicitaste esto, por favor, ignora este e-mail",
    "fr": "Si vous ne l'avez pas demandé, veuillez ignorer cet e-mail",
    "zh": "如果您未曾提出此请求，请忽略此邮件",
    "ja": "このリクエストに心当たりがない場合は、このメールを無視してください  "
  },
  "api__mutation__login__err__creds": {
    "en": "Invalid email or password",
    "pt": "E-mail ou senha inválido",
    "es": "E-mail o contraseña inválidos",
    "fr": "E-mail ou mot de passe non valide",
    "zh": "无效邮箱或密码",
    "ja": "無効なメールアドレスまたはパスワード  "
  },
  "api__mutation__register__err__user_exists": {
    "en": "User already exists",
    "pt": "Usuário já existe ",
    "es": "Usuario ya existe",
    "fr": "L'utilisateur existe déjà",
    "zh": "用户已存在",
    "ja": "ユーザーはすでに存在します  "
  },
  "api__mutation__register__err__user_disabled": {
    "en": "User already exists but is disabled",
    "pt": "O usuário já existe, porém está desativado",
    "es": "El usuario ya existe, pero está desactivado",
    "fr": "L'utilisateur existe déjà, mais il est désactivé",
    "zh": "用户已存在，但已被禁用",
    "ja": "ユーザーはすでに存在しますが無効化されています  "
  },
  "api__mutation__register__err__password_mismatch": {
    "en": "Passwords do not match",
    "pt": "Senhas não coincidem ",
    "es": "Las contraseñas no coinciden",
    "fr": "Les mots de passe ne correspondent pas",
    "zh": "密码不匹配",
    "ja": "パスワードが一致しません  "
  },
  "api__mutation__register__err__field_required": {
    "en": "This field is required",
    "pt": "Este campo é obrigatório",
    "es": "Este campo es obligatorio",
    "fr": "Ce champ est obligatoire",
    "zh": "必填项",
    "ja": "この項目は必須です  "
  },
  "api__mutation__register__err__invalid_country": {
    "en": "Invalid country",
    "pt": "País inválido",
    "es": "País inválido",
    "fr": "Pays invalide",
    "zh": "无效国家",
    "ja": "無効な国  "
  },
  "api__mutation__register__email__subject": {
    "en": "Registration request received",
    "pt": "Requerimento de acesso recebido",
    "es": "Registro de solicitud recibido",
    "fr": "Demande d'inscription reçue",
    "zh": "已收到注册请求",
    "ja": "登録リクエストを受け取りました"
  },
  "api__mutation__register__email__body": {
    "en": "Thank you for requesting access to Adisseo's MilkSmart calculator. Our team will review your application and respond at our earliest availability. You will receive email notification once your application is approved.",
    "pt": "Obrigado por solicitar acesso à calculadora MilkSmart da Adisseo. Nossa equipe irá revisar sua solicitação e responderá assim que possível. Você receberá uma notificação por e-mail assim que sua solicitação for aprovada.",
    "es": "Gracias por solicitar acceso a la calculadora MilkSmart de Adisseo. Nuestro equipo revisará su solicitud y responderá lo antes posible. Recibirá una notificación por e-mail una vez que su solicitud sea aprobada.",
    "fr": "Merci d'avoir demandé l'accès au calculateur Adisseo MilkSmart. Notre équipe examinera votre demande et vous répondra dans les plus brefs délais. Vous recevrez un avis par e-mail une fois votre demande approuvée.",
    "zh": "感谢您申请访问安迪苏的MilkSmart计算器。我们团队将审核您的申请，并尽早回复您。您的申请一旦获批，您将收到电子邮件通知。",
    "ja": "AdisseoのMilkSmartへのアクセスをリクエストいただきありがとうございます。私たちのチームが申請内容を確認次第ご連絡させて頂きます。申請が承認され次第、メール通知をお送り致します。"
  },
  "api__mutation__reset_password__err__expired": {
    "en": "Password reset link is invalid or expired",
    "pt": "O link para resetar a senha é inválido ou expirou",
    "es": "El enlace para restablecer la contraseña es inválido o ha expirado",
    "fr": "Le lien de réinitialisation du mot de passe n'est pas valide ou a expiré",
    "zh": "密码重置链接无效或已过期",
    "ja": "パスワードリセットリンクが無効か期限切れです  "
  },
  "api__mutation__reset_password__err__password_mismatch": {
    "en": "Passwords do not match",
    "pt": "Senhas não coincidem ",
    "es": "Las contraseñas no coinciden",
    "fr": "Les mots de passe ne correspondent pas",
    "zh": "密码不匹配",
    "ja": "パスワードが一致しません  "
  },
  "api__mutation__reset_password__email__subject": {
    "en": "Password reset confirmation",
    "pt": "Confirmação de redefinição da senha",
    "es": "Confirmación de restablecimiento de la contraseña",
    "fr": "Confirmation de la réinitialisation du mot de passe",
    "zh": "密码重置确认",
    "ja": "パスワードリセットの確認"
  },
  "api__mutation__reset_password__email__body": {
    "en": "Your password has been successfully reset. If you did not request this change, please contact us immediately.",
    "pt": "Sua senha foi redefinida com sucesso. Se você não pediu para redefinir, por favor, entre em contato conosco imediadatamente.",
    "es": "Su contraseña ha sido restablecida con éxito. Si no solicitó restablecerla, por favor, contáctenos inmediatamente.",
    "fr": "Votre mot de passe a été réinitialisé avec succès. Si vous ne l'avez pas demandé, veuillez nous contacter immédiatement.",
    "zh": "您的密码已成功重置。若非本人操作，请立即与我们联系。",
    "ja": "パスワードは正常にリセットされました。この変更に心当たりがない場合は、直ちにご連絡ください。"
  },
  "api__mutation__template_delete__err__not_found": {
    "en": "Template not found",
    "pt": "Template não encontrado",
    "es": "Plantilla no encontrada",
    "fr": "Modèle non trouvé",
    "zh": "模板未找到",
    "ja": "テンプレートが見つかりません  "
  },
  "api__event__registration_approved__email__subject": {
    "en": "Registration request approved",
    "pt": "Solicitação de registro aprovada",
    "es": "Solicitud de registro aprobada",
    "fr": "Demande d'inscription approuvée",
    "zh": "注册申请已获批",
    "ja": "登録リクエストが承認されました"
  },
  "api__event__registration_approved__email__body": {
    "en": "Thank you for requesting access to Adisseo's MilkSmart Calculator. Your request has been reviewed and approved by our team.\n\nPlease bookmark https://adisseomilksmart.com/ as your primary access point to the calculator.\n\nYou can now log in using the email and password you provided during registration.",
    "pt": "Obrigado por solicitar acesso à Calculadora MilkSmart da Adisseo. Sua solicitação foi revisada e aprovada por nossa equipe.\n\nPor favor, adicione  https://adisseomilksmart.com/  aos seus favoritos como seu principal ponto de acesso à calculadora.\n\nAgora você pode fazer login usando o e-mail e a senha fornecidos durante o cadastro.",
    "es": "Gracias por solicitar acceso a la Calculadora MilkSmart de Adisseo. Su solicitud ha sido revisada y aprobada por nuestro equipo.\n\nPor favor, guarde  https://adisseomilksmart.com/  en sus favoritos como su principal punto de acceso a la calculadora.\n\nAhora puede iniciar sesión con el e-mail y la contraseña proporcionados durante el registro.",
    "fr": "Merci d'avoir demandé l'accès au calculateur Adisseo MilkSmart. Votre demande a été examinée par notre équipe et a été acceptée.\n\nVeuillez enregistrer  https://adisseomilksmart.com/  comme principal moyen d'accéder au calculateur.\n\nVous pouvez maintenant vous connecter avec l'adresse e-mail et le mot de passe que vous avez fournis lors de l'inscription.",
    "zh": "感谢您申请访问安迪苏的MilkSmart计算器。您的申请已由我们的团队审核并批准。\n\n请将  https://adisseomilksmart.com/  保存为您访问该计算器的主要网址。\n\n您现在可以使用注册时提供的电子邮箱和密码登录了。",
    "ja": "AdisseoのMilkSmart Calculator へのアクセスリクエストありがとうございます。リクエストは当社のチームによって確認され、承認されました。\n\n今後、https://adisseomilksmart.com/ をブックマークして、計算ツールへの主要なアクセスポイントとしてご利用ください。\n\n登録時にご提供いただいたメールアドレスとパスワードで、ログインできるようになりました。\n"
  },
  "api__event__pdf_report__email__subject": {
    "en": "MilkSmart PDF Report",
    "pt": "Relatório PDF do MilkSmart",
    "es": "Informe PDF de MilkSmart ",
    "fr": "Rapport PDF MilkSmart",
    "zh": "MilkSmart PDF报告",
    "ja": "MilkSmart PDFレポート  "
  },
  "api__event__pdf_report__email__body": {
    "en": "Please find attached the PDF report you requested.",
    "pt": "Por favor, encontre em anexo o relatório PDF que você solicitou.",
    "es": "Por favor, encuentre adjunto el informe PDF que solicitó.",
    "fr": "Veuillez trouver ci-joint le rapport PDF que vous avez demandé.",
    "zh": "请查收附件中的 PDF 报告。",
    "ja": "添付のPDFレポートをご確認ください。"
  },
  "common__err__load_failed": {
    "en": "Could not load your data. Please check your connection."
  },
  "common__button__retry": {
    "en": "Try again"
  }
}